module.exports = __webpack_public_path__ + "3c76e188375fd37cb170ba067c9e1240.jpg";